import React, { Fragment, useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { Typography, Grid, Radio, RadioGroup, FormControlLabel, FormControl, Button } from '@material-ui/core';
import Questions from '../Questions';
import Timer from '../Timer';
import Constants from '../../Constants'
import useProfile from '../../Hooks/useProfile'
import Quiz from '../Quiz';
import { toast } from 'react-toastify'

const QuizCompo = React.memo(() => {

    const history = useHistory();

    const [question2, setQuestion2] = useState([]);
    const [disableQuestion, setDisableQuestion] = useState(false);
    
    const { loader, showLoader, hideLoader } = useProfile();

    // Set Answer2 State
    const [answer2, setAnswer2] = useState({
        question16: "", question17: "", question18: "", question19: "", question20: "", question21: "", question22: "",
        question23: "", question24: "",
        ans16: "c", ans17: "b", ans18: "d", ans19: "d", ans20: "e", ans21: "a", ans22: "b",
        ans23: "c", ans24: "a"
    });

    // HandleChange Input2
    const handleChange = (e) => {
        setAnswer2((prevProps) => ({
            ...prevProps,
            [e.target.name]: e.target.value 
        }));
    }

    const submitHandler = async () => {
        showLoader();
        const response = await fetch(Constants.url + 'questions/question2', {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `Bearer ${JSON.parse(localStorage.getItem('token'))}`
            },
            body: JSON.stringify(answer2)
        });
        const result = await response.json();
        if (result.status === 'success') {
            history.push('/dbda_na')
            sessionStorage.setItem('Qpoints',JSON.stringify({q1p1:'1',q1p2:'1',q2:'0',q3:'0',q4:'0',q5:'0',q6:'0',q7:'0',pq:'0'}));
            hideLoader()
            toast.success(result.message);
        }
        else {
            hideLoader()
            toast.error(result.message);
            return false;
        }
    }

    useEffect(() => {
        setQuestion2(Questions['DBDA-VA PART-II'])
    },[])


    return (
        <Fragment>
            <div>
                <Typography variant="h6" color="inherit" >VA-Verbal ability</Typography>
                <Timer initialMinute="3" initialSeconds="30" setDisableQuestion={setDisableQuestion} hideonCheck="0"></Timer>
                <Grid container direction="row" spacing={2} alignItems="center" className="col_base Questions">
                    {
                        question2.map((item, index) => (
                            <Fragment key={index} >
                                <Grid item md={6} lg={6}>
                                    <Typography variant="h6" color="inherit"><span className="me-3 dot">{item.id}.</span> {item.question}</Typography>
                                    <FormControl component="fieldset">
                                        <RadioGroup aria-label={`question${item.id}`} name={`question${item.id}`} value={answer2.question} onChange={handleChange}>
                                            <FormControlLabel value='a' control={<Radio />} label={item.a} disabled={disableQuestion} />
                                            <FormControlLabel value='b' control={<Radio />} label={item.b} disabled={disableQuestion} />
                                            <FormControlLabel value='c' control={<Radio />} label={item.c} disabled={disableQuestion} />
                                            <FormControlLabel value='d' control={<Radio />} label={item.d} disabled={disableQuestion} />
                                            <FormControlLabel value='e' control={<Radio />} label={item.e} disabled={disableQuestion} />
                                        </RadioGroup>
                                    </FormControl>
                                </Grid>
                            </Fragment>
                        ))
                    }
                </Grid>
            </div>
            <div>
                <Fragment>
                    <Button variant="contained" color="primary" onClick={submitHandler}>
                        Next</Button>
                </Fragment>
            </div>
            {loader}
        </Fragment>
    )
});

const Question2 = React.memo(() => {

    return (
        <Quiz QuizCompo={QuizCompo} />
    )
});

export default Question2
